export default __webpack_public_path__ + "static/media/dashboard-settings.9f7e0030.svg";